import React from 'react';
import './WishlistSection.css';
import { usePolicyContext } from '../context/PolicyContext';
import steamBackground from '../assets/网站设计/PC端切图/steam_border.webp';
import steamLogoText from '../assets/网站设计/PC端切图/steam_logo_text.webp';
import steamButton from '../assets/网站设计/PC端切图/steam按钮.webp';

interface WishlistSectionProps {
  isMobile: boolean;
}

const WishlistSection: React.FC<WishlistSectionProps> = ({ isMobile }) => {
  const { isPolicyAccepted } = usePolicyContext()
  // 获取UTM参数的函数
  const getUTMParams = () => {
    const urlParams = new URLSearchParams(window.location.search);

    // 获取原始UTM参数
    const utmCampaign = urlParams.get('utm_campaign') || '';
    const utmMedium = urlParams.get('utm_medium') || '';
    const utmContent = urlParams.get('utm_content') || '';

    // utm_source 手动改为 LandingPage
    const utmSource = 'LandingPage';

    return {
      utm_source: utmSource,
      utm_campaign: utmCampaign,
      utm_medium: utmMedium,
      utm_content: utmContent
    };
  };

  return (
    <section className={`wishlist-section ${isMobile ? 'wishlist-section--mobile' : 'wishlist-section--desktop'}`}>
      <div className="wishlist-container">
        <div
          className="wishlist-content"
          style={{
            borderImageSource: `url(${steamBackground})`
          }}
        >
          <div className="wishlist-text">
            <div className="wishlist-line">
              <span className="wishlist-label">WISHLIST</span>
              <span className="wishlist-now-on">NOW ON</span>
            {isMobile && <img src={steamLogoText} alt="Steam" className="steam-logo-text" />}
            </div>
            {!isMobile && <img src={steamLogoText} alt="Steam" className="steam-logo-text" />}
          </div>

          <div className="steam-section">
            <button
              className="steam-button"
              onClick={() => {
                // 检查是否接受了 Policy

                // 获取UTM参数
                const utmParams = getUTMParams();

                // 发送 GameAnalytics 事件（仅在接受 Policy 后）
                if (isPolicyAccepted && (window as any).GameAnalyticsTracker) {
                  (window as any).GameAnalyticsTracker.trackEvent(
                    'purchase',
                    'Purchase',
                    {
                      total_amount: 1,
                      currency: 'USD',
                      ...utmParams  // 添加UTM参数
                    },
                    true
                  );
                } else if (!isPolicyAccepted) {
                  console.warn('GameAnalytics tracking blocked: Policy not accepted');
                }

                // 发送 Google Ads 转换事件
                if (typeof (window as any).gtag === 'function') {
                  (window as any).gtag('event', 'conversion', {
                    'send_to': 'AW-17488404055/eYxHCJ7kn6YbENe8j5NB',
                    'value': 1.0,
                    'currency': 'USD',
                    'transaction_id': ''
                  });
                  console.log('Google Ads conversion event sent: Purchase');
                } else {
                  console.warn('Google Ads gtag not available');
                }

                // 构建带UTM参数的Steam链接
                const steamBaseUrl = 'https://store.steampowered.com/app/1067360/Pax_Autocratica/';
                const steamUrlParams = new URLSearchParams();

                // 添加UTM参数到Steam链接
                if (utmParams.utm_source) steamUrlParams.append('utm_source', 'LandingPage');
                if (utmParams.utm_campaign) steamUrlParams.append('utm_campaign', utmParams.utm_campaign);
                if (utmParams.utm_medium) steamUrlParams.append('utm_medium', utmParams.utm_medium);
                if (utmParams.utm_content) steamUrlParams.append('utm_content', utmParams.utm_content);

                const steamUrlWithParams = `${steamBaseUrl}?${steamUrlParams.toString()}`;

                // 跳转到 Steam 页面（无论是否接受 Policy 都允许）
                window.open(steamUrlWithParams, '_blank');
              }}
            >
              <img
                src={steamButton}
                alt="Add to your wishlist"
                className="steam-button-img"
              />
              <span className="steam-button-text">Add to your wishlist</span>
            </button>
          </div>
          {isMobile && (
            <p className="launch-eta">Early Access Launch August 10 (Wishlist to get notified)</p>
          )}

        </div>

      </div>
    </section>
  );
};

export default WishlistSection;